import { Injectable, Inject } from '@angular/core';

import { HttpClient, HttpParams } from '@angular/common/http';

import { catchError, map } from 'rxjs/operators';

import { checkValidResponse, logError } from '@cigna/chcp/shared/util';
import { AlertItem, AlertRaw } from './alerts.model';
import {
  ENVIRONMENT_CONFIG,
  EnvironmentConfig,
} from '@cigna/chcp/shared/environment-util';

@Injectable({ providedIn: 'root' })
export class AlertsService {
  public CONSUMER_CODE = '1000';

  public dashboardApi: string;
  public publicAlertsApi: string;
  public gsgApi: string;

  constructor(
    private http: HttpClient,
    @Inject('secureApi') secureApi: string,
    @Inject('publicApi') publicApi: string,
    @Inject('consumerCode') public consumerCode: string,
    @Inject(ENVIRONMENT_CONFIG) private envConfig: EnvironmentConfig,
  ) {
    this.dashboardApi = `${secureApi}/dashboard/v1`;
    this.publicAlertsApi = `${publicApi}/v2/alerts`;
    this.gsgApi = `${envConfig.api.gateways.gsgSecureApi}/caas/api/v1/athlv/contents`;
  }

  getSecureAlertsAws(lob?: string | null) {
    const params: HttpParams = new HttpParams().set(
      'line_of_business',
      lob || 'MEDBH',
    );
    return this.http.get(`${this.gsgApi}/alert`, { params }).pipe(
      map(checkValidResponse),
      map((res) => res.contents.map(this.parseAlert)),
      catchError(logError),
    );
  }

  getPublicAlerts() {
    const params: HttpParams = new HttpParams().set(
      'consumerCode',
      this.consumerCode,
    );

    return this.http
      .get(`${this.publicAlertsApi}`, {
        params,
      })
      .pipe(
        map(checkValidResponse),
        map((res) => res.alerts.map(this.parseAlert)),
        catchError(logError),
      );
  }

  parseAlert(alert: AlertRaw): AlertItem {
    return {
      id: alert.id,
      category: alert.category,
      subcategory: alert.subcategory,
      body: alert.content.item.body.replace(/^<p[^>]*>|<\/p>$/g, ''), // api comes wrapped in <p></p>, we dont want that
      header: alert.content.item.header,
    };
  }
}
